import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class HelpRequests extends CommonCRUD {}

export default HelpRequests;
